import {AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {forEach} from 'lodash';
import {ImageZoomerComponent} from '../image-zoomer/image-zoomer.component';
import {ImageZoomerService} from '../../services/image-zoomer.service';

@Component({
  selector: 'app-confluence-page',
  templateUrl: './confluence-page.component.html',
  styleUrls: ['./confluence-page.component.scss']
})
export class ConfluencePageComponent implements OnInit, OnChanges {
  private API_URL: string = `${environment.baseUrl}/api/wiki/pages/`;
  private HTTP_OPTIONS = {
    headers: new HttpHeaders({
      'Accept': 'application/json'
    })
  };

  private imageMode: boolean = false;

  @ViewChild('container') public container: ElementRef;
  @Input('pageId') public pageId: number;
  public html?: string;

  constructor(
    private readonly _http: HttpClient,
    private imageZoomerS: ImageZoomerService
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateHtml();
  }

  ngOnInit() {
    if (this.pageId === undefined) {
      return;
    }

    this.updateHtml();
  }

  updateHtml() {
    this.html = undefined;
    this._http.get(`${this.API_URL}${this.pageId}`, this.HTTP_OPTIONS).subscribe(data => {
      this.html = data['html'];

      // Wait until the HTML is correctly rendered
      setTimeout(() => {
        // Initializes JS events to create the dropdown effect
        forEach(this.container.nativeElement.getElementsByClassName('expand-control'), (el) => {
          el.addEventListener('click', e => {
            let content = el.nextElementSibling;
            el.classList.toggle('expand-shown');
            content.classList.toggle('expand-hidden');
          });
        });

        // Initializes the zoom image mode
        forEach(this.container.nativeElement.getElementsByClassName('confluence-embedded-image'), (el) => {
          el.addEventListener('click', e => {
            const srcSet = el.srcset.split(',')[0].split(' ')[0];
            this.imageZoomerS.open(srcSet);
          })
        });
      }, 50);
    });
  }
}
